<div class="box">
    <div class="box-row header">
        <app-header-bar [title]="'dashboard.title'"></app-header-bar>
    </div>
    <div class="content mt-2 mb-3">
    </div>
</div>
